export default ({ enrolledUsers, enrollmentsSelectedUsers }) => {
  const {
    data: {
      meta: {
        course_attendance_max: maximum,
        course_session_enforce_attendance_max: shouldEnforceMaximum,
        count: currentEnrolledUsersCount,
      },
    },
  } = enrolledUsers;
  const {
    data: { count: selectedCount },
  } = enrollmentsSelectedUsers;

  const totalCount = currentEnrolledUsersCount + selectedCount;
  const difference = totalCount - maximum;

  return {
    difference,
    maximum,
    selectedCount,
    shouldEnforceMaximum,
    totalCount,
  };
};
